import React, {useEffect} from 'react';
import './OauthAuthenticationError.scss';
import {useTranslation} from "react-i18next";
import Hero from "../../common/Hero/Hero";
import {useDispatch} from "react-redux";
import {hideLoading} from "../../../reducers/app";

const OauthAuthenticationError = (props) => {
  const {t} = useTranslation();
  const {location} = props;
  const {search} = location;
  const dispatch = useDispatch();
  let searchParams = new URLSearchParams(search);
  let errorCode = searchParams.get('statusMessage')?searchParams.get('statusMessage').replace(' ', '_').toLowerCase():'generic_error_message';
  useEffect(() => {
    dispatch(hideLoading());
    // eslint-disable-next-line
  }, [])
  return (
    <div className="OauthAuthenticationError" data-testid="OauthAuthenticationError">
      <Hero title={t("spid_error.title")} description={t("spid_error.description")}/>
      <div className={"Login w-100 h-200 container"}>
        <div className={"row justify-content-md-center"}>
          <div className="col-md-12 text-center mb-5">
            <p>{t(`oauth_${errorCode}`)}</p>
          </div>
        </div>
      </div>
    </div>
  )
};

OauthAuthenticationError.propTypes = {};

export default OauthAuthenticationError;


